import { styled } from "@mui/material/styles"
import { Box, CardHeader, Container, Typography, Grid, IconButton, Stepper, Stack } from "@mui/material"
import { DataGrid } from "@mui/x-data-grid"
import { Link } from "react-router-dom"

export const fabStyle = {
  position: "absolute",
  bottom: 8,
}

export const mainBoxStyle = {
  flexGrow: 1,
  pb: 8,
  pt: 4,
}

export const deviderStyle = {
  borderColor: "#2D3748",
  my: 3,
}

export const IndicatorBoxContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: 10,
  width: "100%",
}))

export const CardTableHeader = styled(CardHeader)(({ theme }) => ({
  padding: "24px 16px 0px",
}))

export const MainComponent = styled(Box)(({ theme }) => ({
  flexGrow: 1,
}))

export const AppLoadingContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  height: "100%",
  backgroundColor: "white",
}))

export const FormWrapper = styled(Stack)(({ theme }) => ({
  padding: 16,
}))

export const ContentWrapper = styled(Container)(({ theme }) => ({
  height: "100%",
  display: "flex",
  flexDirection: "column",
  paddingBottom: 8,
  paddingLeft: "16px !important",
  paddingRight: "16px !important",
  maxWidth: "unset !important",
}))

export const ListResultWrapper = styled(Box)(({ theme }) => ({
  marginTop: 16,
  flex: 1,
  display: "flex",
  position: "relative",
}))

export const InfoText = styled(Typography)(({ theme }) => ({
  color: "rgba(0,0,0,.8)",
  wordBreak: "break-word",
  fontWeight: "bold",
  marginLeft: 16,
}))

export const GridContainer = styled(Grid)(({ theme }) => ({
  backgroundColor: "white",
  paddingTop: 24,
  paddingBottom: 24,
  marginLeft: 0,
  width: "100%",
}))

export const FormBottomButtonsWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  flex: 1,
}))

export const ProgressWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
}))

export const CustomStepper = styled(Stepper)(({ theme }) => ({
  padding: "8px 0",
}))

export const CustomCloseIcon = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  right: 8,
  top: 8,
}))

export const DialogTitleWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: "#f8e714",
  marginBottom: 1,
}))

export const CustomDataGrid = styled(DataGrid)(({ theme }) => ({
  backgroundColor: "white",
  borderRadius: 0,
}))

export const SummaryBox = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-end",
  padding: 8,
}))

export const WarningWrapper = styled(Stack)(({ theme }) => ({
  alignItems: "center",
  padding: 8,
}))

export const CommonHyperlink = styled(Link)(({ theme }) => ({
  textDecorationLine: "underline",
  fontWeight: 600,
  cursor: "pointer",
  color: "#000",
  ":hover": {
    backgroundColor: "#f3da00",
    fontWeight: 700,
  },
}))
